<script>
import {h} from 'vue';
import ArticleAbout from '@/components/article/ArticleAbout.vue';
import ArticleClients from '@/components/article/ArticleClients.vue';
import ArticleContact from '@/components/article/ArticleContact.vue';
import ArticleHome from '@/components/article/ArticleHome.vue';
import ArticleTerms from '@/components/article/ArticleTerms.vue';

export default {
    // https://stackoverflow.com/questions/70957780/how-i-can-render-a-component-from-a-string-with-vue-3
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render() {
        const r = {
            components: {
                ArticleAbout,
                ArticleClients,
                ArticleContact,
                ArticleHome,
                ArticleTerms,
            },
            template: `
                <div class="content-compiled">${this.html || ''}</div>`,
            /**
            methods: {
                hello () {
                    // method "hello" is also available here
                },
            },
            **/
        };
        return h(r);
    },
};
</script>
